import React from 'react';

import { useEncaisseData } from '@/hooks/accueil';
import TileEncaisse from '../tiles/TileEncaisse';

type TileEncaisseContainerPropsType = {
  /** Force un refresh des données */
  forceRefresh?: boolean;
};

/**
 * Conteneur smart pour TileEncaisse
 * Gère automatiquement la récupération des données et le cache
 */
const TileEncaisseContainer = ({ forceRefresh }: TileEncaisseContainerPropsType) => {
  const { encaisse, loading, refresh } = useEncaisseData();

  // Effet pour forcer le refresh quand demandé par le parent
  React.useEffect(() => {
    if (forceRefresh) {
      refresh();
    }
  }, [forceRefresh, refresh]);

  return <TileEncaisse encaisse={encaisse} loading={loading} />;
};

export default TileEncaisseContainer;
